import { AbstractControl, FormGroup } from '@angular/forms';

export function BusinessPremiseValidator(group: AbstractControl) {
  const failingValidations: any = {};
  if (group.get('type').value === 'realestate') {
    if (!group.get('street').value || group.get('street').value === '') {
      failingValidations.street = true;
    }

    if (!group.get('houseNumber').value || group.get('houseNumber').value === '') {
      failingValidations.houseNumber = true;
    }

    if (!group.get('city').value || group.get('city').value === '') {
      failingValidations.city = true;
    }

    if (!group.get('postalCode').value || group.get('postalCode').value === '') {
      failingValidations.postalCode = true;
    }

    const cadastralNumberVal = group.get('cadastralNumber').value;

    if (!cadastralNumberVal || cadastralNumberVal === '') {
      failingValidations.cadastralNumberRequired = true;
    }

    if (cadastralNumberVal && !/^[0-9]{1,4}$/.test(cadastralNumberVal)) {
      failingValidations.cadastralNumberFormat = true;
    }

    const buildingNumberVal = group.get('buildingNumber').value;

    if (!buildingNumberVal || buildingNumberVal === '') {
      failingValidations.buildingNumberRequired = true;
    }

    if (buildingNumberVal && !/^[0-9]{1,5}$/.test(buildingNumberVal)) {
      failingValidations.buildingNumberFormat = true;
    }

    const buildingSectionNumberVal = group.get('buildingSectionNumber').value;

    if (!buildingSectionNumberVal || buildingSectionNumberVal === '') {
      failingValidations.buildingSectionNumberRequired = true;
    }

    if (buildingSectionNumberVal && !/^[0-9]{1,4}$/.test(buildingSectionNumberVal)) {
      failingValidations.buildingSectionNumberFormat = true;
    }

    if (!group.get('community').value || group.get('community').value === '') {
      failingValidations.community = true;
    }

  } else if (group.get('type').value === 'movable') {
    if (!group.get('premiseType').value || group.get('premiseType').value === '') {
      failingValidations.premiseType = true;
    }
  }

  return Object.keys(failingValidations).length > 0 ? failingValidations : null;
}
